import { TYPE_DISMISS_DIALOG } from 'data/dialog';
import {
  TYPE_RECEIVE_INSIGHTS_ERROR,
  TYPE_RECEIVE_INSIGHT_ERROR,
  TYPE_CREATE_INSIGHT_SUCCESS,
  TYPE_CREATE_INSIGHT_ERROR,
  TYPE_UPDATE_INSIGHT_SUCCESS,
  TYPE_UPDATE_INSIGHT_ERROR,
  TYPE_RECEIVE_INSIGHT_TEST,
  TYPE_RECEIVE_INSIGHT_TEST_ERROR
} from 'data/insights';
import {
  TYPE_RECEIVE_LABELS_ERROR,
  TYPE_RECEIVE_LABEL_ERROR,
  TYPE_UPDATE_LABEL_SUCCESS,
  TYPE_UPDATE_LABEL_ERROR,
  TYPE_CREATE_LABEL_SUCCESS,
  TYPE_CREATE_LABEL_ERROR,
  TYPE_RECEIVE_CLUSTERS_ERROR,
  TYPE_CREATE_CLUSTER_SUCCESS,
  TYPE_CREATE_CLUSTER_ERROR
} from 'data/labels';
import {
  TYPE_RECEIVE_PLEDGES_ERROR,
  TYPE_RECEIVE_PLEDGE_ERROR,
  TYPE_UPDATE_PLEDGE_SUCCESS,
  TYPE_UPDATE_PLEDGE_ERROR,
  TYPE_CREATE_PLEDGE_SUCCESS,
  TYPE_CREATE_PLEDGE_ERROR
} from 'data/pledges';
import {
  TYPE_RECEIVE_SURVEYS_ERROR,
  TYPE_RECEIVE_SURVEY_ERROR,
  TYPE_UPDATE_SURVEY_SUCCESS,
  TYPE_UPDATE_SURVEY_ERROR,
  TYPE_CREATE_SURVEY_SUCCESS,
  TYPE_CREATE_SURVEY_ERROR
} from 'data/surveys';
import {
  TYPE_RECEIVE_TRACKS_ERROR,
  TYPE_RECEIVE_TRACK_ERROR,
  TYPE_UPDATE_TRACK_SUCCESS,
  TYPE_UPDATE_TRACK_ERROR,
  TYPE_CREATE_TRACK_SUCCESS,
  TYPE_CREATE_TRACK_ERROR
} from 'data/tracks';
import { TYPE_RECEIVE_FORMATTERS_ERROR } from 'data/formatters';

const initState = [];

const insightReducer = action => {
  switch (action.type) {
    case TYPE_RECEIVE_INSIGHTS_ERROR:
      return { variant: 'error', message: action.error || 'Unable to fetch insights.' };
    case TYPE_RECEIVE_INSIGHT_ERROR:
      return { variant: 'error', message: action.error || 'Unable to fetch insight.' };
    case TYPE_CREATE_INSIGHT_SUCCESS:
      return { variant: 'success', message: `Successfully created ${action.insight.name}` };
    case TYPE_CREATE_INSIGHT_ERROR:
      return {
        variant: 'error',
        message: action.error || 'There was a problem creating the insight.'
      };
    case TYPE_UPDATE_INSIGHT_SUCCESS:
      return { variant: 'success', message: `Successfully updated ${action.insight.name}` };
    case TYPE_UPDATE_INSIGHT_ERROR:
      return {
        variant: 'error',
        message: action.error || 'There was a problem updating the insight.'
      };
    case TYPE_RECEIVE_INSIGHT_TEST:
      return { variant: 'error', message: 'Success! All tests in Labels passed.' };
    case TYPE_RECEIVE_INSIGHT_TEST_ERROR:
      return { variant: 'error', message: action.error };
    default:
      return;
  }
};

const labelReducer = action => {
  switch (action.type) {
    case TYPE_RECEIVE_LABELS_ERROR:
      return { variant: 'error', message: action.error || 'Unable to fetch labels.' };
    case TYPE_RECEIVE_LABEL_ERROR:
      return { variant: 'error', message: action.error || 'Unable to fetch label.' };
    case TYPE_UPDATE_LABEL_SUCCESS:
      return { variant: 'success', message: `Successfully updated label ${action.label.id}.` };
    case TYPE_UPDATE_LABEL_ERROR:
      return {
        variant: 'error',
        message: action.error || 'There was a problem updating the label.'
      };
    case TYPE_CREATE_LABEL_SUCCESS:
      return { variant: 'success', message: `Successfully created label ${action.label.id}.` };
    case TYPE_CREATE_LABEL_ERROR:
      return {
        variant: 'error',
        message: action.error || 'There was a problem creating the label.'
      };
    case TYPE_RECEIVE_CLUSTERS_ERROR:
      return { variant: 'error', message: action.error || 'Unable to fetch clusters.' };
    case TYPE_CREATE_CLUSTER_SUCCESS:
      return { variant: 'success', message: `Successfully created cluster ${action.clusterName}.` };
    case TYPE_CREATE_CLUSTER_ERROR:
      return {
        variant: 'error',
        message: action.error || 'There was a problem creating the cluster.'
      };
    default:
      return;
  }
};

const pledgesReducer = action => {
  switch (action.type) {
    case TYPE_RECEIVE_PLEDGES_ERROR:
      return { variant: 'error', message: action.error || 'Unable to fetch pledges.' };
    case TYPE_RECEIVE_PLEDGE_ERROR:
      return { variant: 'error', message: action.error || 'Unable to fetch pledge.' };
    case TYPE_UPDATE_PLEDGE_ERROR:
      return { variant: 'error', message: action.error || 'Unable to update pledge.' };
    case TYPE_UPDATE_PLEDGE_SUCCESS:
      return { variant: 'success', message: `Successfully updated pledge ${action.pledge.id}.` };
    case TYPE_CREATE_PLEDGE_ERROR:
      return { variant: 'error', message: action.error || 'Unable to create pledge.' };
    case TYPE_CREATE_PLEDGE_SUCCESS:
      return { variant: 'success', message: `Successfully created pledge ${action.pledge.id}.` };
    default:
      return;
  }
};

const surveysReducer = action => {
  switch (action.type) {
    case TYPE_RECEIVE_SURVEYS_ERROR:
      return { variant: 'error', message: action.error || 'Unable to fetch surveys.' };
    case TYPE_RECEIVE_SURVEY_ERROR:
      return { variant: 'error', message: action.error || 'Unable to fetch survey.' };
    case TYPE_UPDATE_SURVEY_ERROR:
      return { variant: 'error', message: action.error || 'Unable to update survey.' };
    case TYPE_UPDATE_SURVEY_SUCCESS:
      return { variant: 'success', message: `Successfully updated survey ${action.survey.id}.` };
    case TYPE_CREATE_SURVEY_ERROR:
      return { variant: 'error', message: action.error || 'Unable to create survey.' };
    case TYPE_CREATE_SURVEY_SUCCESS:
      return { variant: 'success', message: `Successfully created survey ${action.survey.id}.` };
    default:
      return;
  }
};

const tracksReducer = action => {
  switch (action.type) {
    case TYPE_RECEIVE_TRACKS_ERROR:
      return { variant: 'error', message: action.error || 'Unable to fetch tracks.' };
    case TYPE_RECEIVE_TRACK_ERROR:
      return { variant: 'error', message: action.error || 'Unable to fetch track.' };
    case TYPE_UPDATE_TRACK_ERROR:
      return { variant: 'error', message: action.error || 'Unable to update track.' };
    case TYPE_UPDATE_TRACK_SUCCESS:
      return { variant: 'success', message: `Successfully updated track ${action.track.id}.` };
    case TYPE_CREATE_TRACK_ERROR:
      return { variant: 'error', message: action.error || 'Unable to create track.' };
    case TYPE_CREATE_TRACK_SUCCESS:
      return { variant: 'success', message: `Successfully created track ${action.track.id}.` };
    default:
      return;
  }
};

/**
 * Sub reducer to build a message from a formatters action
 */
function formatters(action) {
  if (action.type === TYPE_RECEIVE_FORMATTERS_ERROR) {
    return { variant: 'error', message: action.error || 'Unable to fetch formatters.' };
  }
}

export default (state = initState, action) => {
  switch (action.type) {
    case TYPE_DISMISS_DIALOG:
      return state.slice(1);
    case TYPE_UPDATE_INSIGHT_SUCCESS:
    case TYPE_UPDATE_INSIGHT_ERROR:
    case TYPE_CREATE_INSIGHT_SUCCESS:
    case TYPE_CREATE_INSIGHT_ERROR:
    case TYPE_RECEIVE_INSIGHT_TEST:
    case TYPE_RECEIVE_INSIGHT_TEST_ERROR:
      return [...state, insightReducer(action)];
    case TYPE_RECEIVE_LABELS_ERROR:
    case TYPE_UPDATE_LABEL_SUCCESS:
    case TYPE_UPDATE_LABEL_ERROR:
    case TYPE_CREATE_LABEL_SUCCESS:
    case TYPE_CREATE_LABEL_ERROR:
    case TYPE_RECEIVE_CLUSTERS_ERROR:
    case TYPE_CREATE_CLUSTER_SUCCESS:
    case TYPE_CREATE_CLUSTER_ERROR:
      return [...state, labelReducer(action)];
    case TYPE_CREATE_PLEDGE_SUCCESS:
    case TYPE_CREATE_PLEDGE_ERROR:
    case TYPE_UPDATE_PLEDGE_SUCCESS:
    case TYPE_UPDATE_PLEDGE_ERROR:
      return [...state, pledgesReducer(action)];
    case TYPE_RECEIVE_SURVEYS_ERROR:
    case TYPE_RECEIVE_SURVEY_ERROR:
    case TYPE_UPDATE_SURVEY_SUCCESS:
    case TYPE_UPDATE_SURVEY_ERROR:
    case TYPE_CREATE_SURVEY_SUCCESS:
    case TYPE_CREATE_SURVEY_ERROR:
      return [...state, surveysReducer(action)];
    case TYPE_RECEIVE_TRACKS_ERROR:
    case TYPE_RECEIVE_TRACK_ERROR:
    case TYPE_UPDATE_TRACK_SUCCESS:
    case TYPE_UPDATE_TRACK_ERROR:
    case TYPE_CREATE_TRACK_SUCCESS:
    case TYPE_CREATE_TRACK_ERROR:
      return [...state, tracksReducer(action)];
    case TYPE_RECEIVE_FORMATTERS_ERROR:
      return [...state, formatters(action)];
    default:
      return state;
  }
};
